import Countly from 'countly-sdk-web'
import { createApp } from 'vue'
import VueCountly from 'vue-countly'
import 'vuetify/dist/vuetify.min.css'
import packageJson from '../package.json'
import App from './App.vue'
import keycloak from './keycloak'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store/store'
import { ActionTypes } from './store/store_types'

export let app: any

class PowertripPowersell extends HTMLElement {
  connectedCallback() {
    app = createApp(App, {
      created() {
        console.log('Analytics is running:', this.$Countly === Countly)
        ;(this.$Countly as typeof Countly).q.push(['track_sessions']) // Track sessions automatically (recommended)
        ;(this.$Countly as typeof Countly).q.push(['track_pageview']) // Track web page views automatically (recommended)
        ;(this.$Countly as typeof Countly).q.push(['track_errors']) // report unhandled errors to analytics.
      },
    })

    app.use(router)
    app.use(store)
    app.use(vuetify)

    // Analytics.
    app.use(VueCountly, Countly, {
      app_key: '72ab10f127702075ed811caf5d14fc06b4049015',
      url: 'https://analytics.littlemonkey.co.nz',
      app_version: packageJson.version,
    })

    app.provide('Countly', Countly)

    // Auth
    keycloak.onAuthRefreshError = () => {
      // compile redirect uri
      const redirectUri =
        window.location.origin +
        '/#/logout/' +
        new URLSearchParams('logout_reason=session_expired').toString()

      // Trigger logout process
      store.dispatch(ActionTypes.logoutUser, redirectUri)
    }
    keycloak.init()
    app.mount(this)
  }
}

if (!window.customElements.get('powertrip-powersell')) {
  window.customElements.define('powertrip-powersell', PowertripPowersell)
}
